/// <reference path="../include.ts" />

namespace project_common {

	import Logger = alm.debug.Logger;
	import DeviceInfo = alm.browser.DeviceInfo;
	import Dom = alm.util.Dom;
	import LoggerLevel = alm.debug.LoggerLevel;
	import QueryString = alm.browser.QueryString;

	export class Application {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			Logger.setLevelByQuery('log');
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public run(deployMode:DeployMode):void {
			Application.isInitializing = true;

			if (deployMode === DeployMode.debug) {
				Logger.level = LoggerLevel.verbose;
			}

			Dom.scrollTo(0, false);

			// get embedded context
			Application.presetContext = new PresetContext(deployMode);

			// get banner context
			Application.bannerData = new BannerData();

			// add root class
			this.setupRootClass();

			// setup error view
			this.statusError = new StatusError();
			this.statusError.setContext();
			this.statusError.ready();

			// load init data
			setTimeout(():void => {
				this.loadInitData();
			}, 500);
		}





		private loadInitData():void {
			const url = 'data/' + Application.presetContext.lang + '?revision=' + Application.presetContext.zoneRevision;

			trace('[Application] load data : url =', url);
			const xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.addEventListener('load', ():void => {
				trace('[Application] load data : complete, status =', xhr.status);
				if (xhr.status === 200) {
					// create context
					let json:string = null;
					let data:object = null;
					try {
						json = xhr.responseText;
						data = JSON.parse(json);
					} catch (exception) {
						trace('[Application] load data : parse error, exception =', exception);
						this.loadError();
						return;
					}
					Application.spotJson = json;
					Application.spotData = <Spot>(data);
					trace('[Application] spot data :', data);
					this.loadSuccess();

				} else {
					trace('[Application] load data : load error, status =', xhr.status);
					this.loadError();
				}
			});
			xhr.addEventListener('error', ():void => {
				trace('[Application] load data : load error, status =', xhr.status);
				this.loadError();
			});
			xhr.send();
		}

		private loadError():void {
			Dom.removeRootClass('status-loading');
			Dom.addRootClass('status-error');

			// set error message
			this.statusError.show();
		}

		private loadSuccess():void {
			Dom.removeRootClass('status-loading');
			Dom.addRootClass('status-ready');

			this.start();
		}





		private start():void {
			// setup view
			this.setupView();

			// setup scene
			//this.setupScene();

			// setup touch action
			this.setupTouchAction();

			// start application
			//WindowWatcher.addEventListener(WindowWatcherEvent.RESIZE, this.windowWatcherResizeHandler);
			//WindowWatcher.start();
			//this.resize();

			//KeyWatcher.addEventListener(KeyWatcherEvent.KEY_UP, this.keyWatcherKeyUpHandler);
			//KeyWatcher.start();

			window.addEventListener('hashchange', this.windowHashChangeHandler, false);
			//this.sceneManager.addEventListener(SceneManagerTransferEvent.TRANSFER_START, this.sceneManagerTransferStartHandler);
			//this.sceneManager.start(new SceneTransferMessage(this.context, false, false));
			//this.parseHashAndMove(true, false);

			this.applyPath(window.location.hash, false);

			Application.isInitializing = false;
			trace('[Application] initialized');
		}

		private setupRootClass():void {
			// deploy mode
			Dom.addRootClass('deploy-mode-' + Application.presetContext.deployMode);

			// language
			Dom.addRootAttribute('lang', DeviceInfo.getLang());
			Dom.addRootClass('lang-' + Application.presetContext.lang);

			// browser
			const browser = DeviceInfo.getIsIE() ? 'ie' : 'not-ie';
			Dom.addRootClass('browser-' + browser);
		}

		private setupTouchAction():void {
			jQuery('a,button,.clickable').each((index:number, element:HTMLElement):void => {
				element.addEventListener('touchstart', (event:TouchEvent):void => {});
			});
		}

		private setupView():void {
			//window.document.title = DataParser.localize(this.context.spot.name, this.context.lang) + (this.context.lang === Lang.ja ? ' 生き物ガイド' : ' Guide Book');
			this.implSetupView();
		}





		public applyPath(hash:string, useTransition:boolean = true):void {
			trace('[Application] apply path :', hash);

			// remove #
			let path = hash;
			const hashIndex = hash.indexOf('#');
			if (hashIndex === 0) {
				path = hash.slice(hash.indexOf('#') + 1);
			}

			// get scene names
			const names = path.split('/');

			// remove blank
			while (true) {
				const index = names.indexOf('');
				if (index != -1) {
					names.splice(index, 1);
				} else {
					break;
				}
			}

			// check exist
			let region:Region = null;
			let area:Area = null;
			let zone:Zone = null;
			let species:Species = null;

			if (names[0]) {
				region = DataParser.getRegionFromSpot(Application.spotData, names[0]);
			}

			if (names[1]) {
				area = DataParser.getAreaFromRegion(region, names[1]);
			}

			if (names[2]) {
				zone = DataParser.getZoneFromArea(area, names[2]);
			}

			if (names[3]) {
				species = DataParser.getSpeciesFromZone(zone, names[3]);
			}

			this.applyScene(region, area, zone, species, useTransition);
		}

		public applyScene(region:Region, area:Area, zone:Zone, species:Species, useTransition:boolean = true):void {
			this.implApplyScene(region, area, zone, species, useTransition);
		}





		/*
		private setupScene():void {
			this.sceneManager = new scn.SceneManager('', IndexScene);
			this.sceneManager.addEventListener(SceneManagerRequireSceneEvent.REQUIRE_SCENE, this.sceneManagerRequireSceneHandler);
		}

		private parseHashAndMove(scroll:boolean, smoothScroll:boolean):void {
			// get hash
			const url = window.location.href.split('#');
			let hash = '';
			if (url.length <= 1 || url[0] === '/') {
				hash = '/';
			} else {
				hash = url[1];
			}

			// start transfer
			trace('[Application] hash =', hash);
			this.sceneManager.goto(hash, new SceneTransferMessage(this.context, scroll, smoothScroll));
		}
		*/

		/*
		private resize():void {
			if (this.cardView.getIsShown()) {
				this.cardView.resize();
			}
		}
		*/





		private windowHashChangeHandler = (event:HashChangeEvent):void => {
			//this.parseHashAndMove(true, true);
			this.applyPath(window.location.hash);
		};

		/*
		private sceneManagerTransferStartHandler = (event:SceneManagerTransferEvent):void => {
			const path = event.transferInfo.getDestinationPath();
			const hash = '#' + path;
			if (hash != location.hash) {
				//window.location.href = hash;
				//history.pushState(null, null, hash);
			}
		};

		private sceneManagerRequireSceneHandler = (event:SceneManagerRequireSceneEvent):void => {
			trace('[Router] required scene path :', event.scenePath);
			const sceneNames = this.sceneManager.getSceneNamesByPath(event.scenePath);

			const parentScene = this.sceneManager.getParentSceneByPath(event.scenePath);
			//trace('[Router]     parent scene path :', parentScene.getPath());

			const childSceneName = sceneNames[sceneNames.length - 1];
			const childSceneLevel = this.sceneManager.getSceneLevelByNames(sceneNames);
			//trace('[Router]     child scene : level =', childSceneLevel, ', name =', childSceneName);

			let childScene:Scene = null;
			switch (childSceneLevel) {
				case 1:
					childScene = new RegionScene(childSceneName);
					break;
				case 2:
					childScene = new AreaScene(childSceneName);
					break;
				case 3:
					childScene = new ZoneScene(childSceneName);
					break;
				case 4:
					childScene = new SpeciesScene(childSceneName);
					break;
			}

			if (childScene) {
				parentScene.addChild(childScene);
			}
		};

		private keyWatcherKeyUpHandler = (event:KeyWatcherEvent):void => {
			switch (event.keyCode) {
				case KeyCode.P:
					this.sceneManager.dumpAllPath();
					break;
				case KeyCode.C:
					window.applicationCache.update();
					window.applicationCache.swapCache();
					break;
			}
		};
		*/

		//private windowWatcherResizeHandler = (event:WindowWatcher):void => {
		//	this.resize();
		//};



		protected implSetupView():void {
		}

		protected implApplyScene(region:Region, area:Area, zone:Zone, species:Species, useTransition:boolean):void {
		}




		public static getIsInitializing():boolean {
			return this.isInitializing;
		}

		public static getPresetContext():PresetContext {
			return this.presetContext;
		}

		public static getSpotJson():string {
			return this.spotJson;
		}

		public static getSpotData():Spot {
			return this.spotData;
		}

		public static getBannerData():BannerData {
			return this.bannerData;
		}





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		private static presetContext:PresetContext = null;
		private static spotData:Spot = null;
		private static spotJson:string = null;
		private static bannerData:BannerData = null;
		private static isInitializing:boolean = false;

		private statusError:StatusError;
	}
}
